module.exports = __webpack_public_path__ + "img/IEAIBPLC.1c9ac73a.png";